module.exports = __webpack_public_path__ + "img/previewBackground.fa75bf57.png";